<script setup>
import EmptyCard from '@/components/emptyCard.vue';
import { onMounted } from 'vue';


const props = defineProps({
  package_config:{
    type: Object,
    required: true
  }
})

onMounted(async()=>{
  
})
</script>

<template>
  <div v-auto-animate class="card">
    <div class="card-body row">
      <div v-if="package_config.characters.length !== 0" 
        v-for="character in package_config.characters" 
        :class="package_config.characters.length == 1 ? 'col-md-12' : 'col-md-6'"
      >
        <div class="card  shadow-none border">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table assessment-table">
                <thead>
                  <tr>
                    <td><b>{{ character.name }}</b></td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="trait in character.traits">
                    <td>
                      <p>{{ trait.name }}</p>
                    </td>
                    <td>
                      <div class="justify-content-end">
                        <router-link 
                          class="btn btn-primary px-3"
                          :to="{
                            name: 'assessment-list', 
                            params: {
                              package_id: package_config.id,
                              trait_id: trait.id
                            }
                          }" 
                        >
                          View List
                        </router-link>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <empty-card v-else
        :link="{
          routerObj:{
            name: 'dna-report-report'
          },
          type: 'link',
          class: 'w-50',
          desc: 'Go to package setting'
        }"
      />
    </div>
  </div>
</template>